import React, { Fragment, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import AssignmentPreviewScreen from "../pages/AssignmentPreviewScreen";
import AvailableTimesScreen from "../pages/AvailableTimesScreen";
import CheckoutScreen from "../pages/CheckoutScreen";
import ProfessionalNewReviewsScreen from "../pages/ProfessionalNewReviewsScreen";
import ProfessionalProfileScreen from "../pages/ProfessionalProfileScreen";
import ProfessionalReviewsScreen from "../pages/ProfessionalReviewsScreen";
import ProfessionalsScreen from "../pages/ProfessionalsScreen";
import RescheduleScreen from "../pages/RescheduleScreen";
import ScheduleScreen from "../pages/ScheduleScreen";
import SuccessScreen from "../pages/SuccessScreen";
import TestsScreen from "../pages/TestsScreen";
import UnauthorizedScreen from "../pages/UnauthorizedScreen";
import "./router.css";

const Router = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const showSuccessScreen = window.sessionStorage.getItem("showSuccessScreen") === "true";

	// Adicionar o queryParam 'canGoBack=true' em todas as rotas exceto a rota de sucesso
	useEffect(() => {
		if (location.search.includes("finish=true")) return;

		navigate(
			{
				pathname: location.pathname,
				search:
					location.search.length > 0
						? location.search.includes("canGoBack=true")
							? location.search
							: `${location.search}&canGoBack=true`
						: "?canGoBack=true",
			},
			{ replace: true, state: location.state },
		);
	}, [location.pathname, location.search]);

	return (
		<TransitionGroup component={null}>
			<CSSTransition key={location.pathname} classNames="fade" timeout={300}>
				<Routes location={location}>
					{!showSuccessScreen && ( // globalContext.token
						<Fragment>
							<Route path="consultas" element={<ScheduleScreen />} />
							<Route path="medicos" element={<ProfessionalsScreen />} />
							<Route path="medicos/:professionalId" element={<ProfessionalProfileScreen />} />
							<Route path="medicos/:professionalId/agendamentos" element={<AvailableTimesScreen />} />
							<Route path="medicos/:professionalId/checkout/:checkoutId" element={<CheckoutScreen />} />
							<Route path="medicos/:professionalId/checkout/:checkoutId/reschedule/:rescheduleId" element={<CheckoutScreen />} />
							<Route path="medicos/:professionalId/reviews" element={<ProfessionalReviewsScreen />} />
							<Route path="medicos/:professionalId/agendamentos/:scheduleId/review" element={<ProfessionalNewReviewsScreen />} />
							<Route path="medicos/:professionalId/agendamentos/:scheduleId/preview" element={<AssignmentPreviewScreen />} />
							<Route path="medicos/:professionalId/agendamentos/:scheduleId/reschedule" element={<RescheduleScreen />} />
							<Route path="teste" element={<TestsScreen />} />
						</Fragment>
					)}
					<Route path="success" element={<SuccessScreen />} />
					<Route path={"unauthorized"} element={<UnauthorizedScreen />} />
					<Route path={"*"} element={showSuccessScreen ? <SuccessScreen /> : <UnauthorizedScreen />} />
				</Routes>
			</CSSTransition>
		</TransitionGroup>
	);
};

export default Router;
